import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { bookieAPI } from '../services/api';
import './ClubFund.css';

function PersonalBookie() {
  const { clubId } = useParams();
  const navigate = useNavigate();
  const [launching, setLaunching] = useState(false);

  const isPersonalMode = !clubId;

  const handleLaunch = async (walletType) => {
    setLaunching(true);
    try {
      let data;
      if (isPersonalMode) {
        data = await bookieAPI.getPersonalBetLaunchUrl();
      } else {
        data = await bookieAPI.getBetLaunchUrl(clubId, walletType);
      }
      if (data.success && data.url) {
        window.open(data.url, '_blank');
      }
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to launch bookie');
    }
    setLaunching(false);
  };

  return (
    <div>
      <h2>Personal GRSBet Account</h2>

      <div className="fund-form">
          <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>Access Your Bookie Account</h3>
          <p style={{ color: '#999', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
            Open your GRSBet account to view your personal betting history, manage your account settings, or place personal bets.
          </p>

          <button
            onClick={() => handleLaunch('personal')}
            className="btn-submit"
            disabled={launching}
            style={{ marginBottom: '0.75rem' }}
          >
            {launching ? 'Opening...' : 'Open Personal Account'}
          </button>

          {!isPersonalMode && (
            <button
              onClick={() => handleLaunch('club')}
              style={{ width: '100%', background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.3)', color: '#3b82f6', borderRadius: '8px', padding: '0.85rem', cursor: 'pointer', fontWeight: 600 }}
              disabled={launching}
            >
              Open Club Betting Account
            </button>
          )}
        </div>

        {!isPersonalMode && (
          <div className="fund-form" style={{ marginTop: '1rem' }}>
            <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>Link or Re-link Account</h3>
            <p style={{ color: '#999', fontSize: '0.85rem', marginBottom: '1rem' }}>
              Need to create a new bookie account or link an existing one?
            </p>
            <button
              onClick={() => navigate(`/register/link?clubId=${clubId}&action=new`)}
              style={{ width: '100%', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', color: '#10b981', borderRadius: '8px', padding: '0.7rem', cursor: 'pointer', fontWeight: 600, marginBottom: '0.5rem' }}
            >
              Create New Account
            </button>
            <button
              onClick={() => navigate(`/register/link?clubId=${clubId}&action=existing`)}
              style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#999', borderRadius: '8px', padding: '0.7rem', cursor: 'pointer' }}
            >
              Link Existing Account
            </button>
          </div>
        )}
    </div>
  );
}

export default PersonalBookie;
